import React from "react"
import { Link } from "react-router-dom"
import Back from "../common/Back"
import Heading from "../common/Heading"
import img from "../images/about.jpg"
import "./about.css"

const About = () => {
  return (
    <>
      <section className='about'>
        <Back name='About Us' title='About Vista Hill Houses' cover={img} />
        <div className='container flex mtop'>
          <div className='left row'>
            <Heading title='Our Story' subtitle='We help you find a home — or build the one you’ve always wanted.' />

            <p>Vista Hill Houses started with a simple idea: great real estate should include both finding the right property and creating it from the ground up. We list homes, villas, apartments, and commercial spaces for sale and rent, and we also take on custom build projects — so whether you’re browsing or ready to build, we’re here for you.</p>
            <p>Our team brings together agents who know the market and specialists who manage design and construction. That means one place for search, consultation, and full design-and-build delivery. If you want to build a house or contract us to build for you, we handle the process from idea to keys.</p>
            <Link to='/services'><button className='btn2'>Our Services</button></Link>
          </div>
          <div className='right row'>
            <img src={img} alt='Vista Hill Houses team and properties' />
          </div>
        </div>
      </section>
    </>
  )
}

export default About
